import type { AppDrafts, PlaySnapshot } from '@/api/play';

export interface SourceShot {
  key: string;
  url: string;
}

/**
 * A locale's phone screenshots as (stable key, public URL) pairs — the draft
 * when it has one, else what is live on Play. Shared by the per-locale localize
 * modal and the bulk launch dialog so the two can never disagree about what the
 * source images are.
 */
export function sourceScreenshots(
  snapshot: PlaySnapshot | undefined,
  drafts: AppDrafts | undefined,
  source: string,
): SourceShot[] {
  const live = snapshot?.images?.[source]?.phoneScreenshots ?? [];
  const draft = (drafts?.images ?? []).find(
    (d) => d.language === source && d.imageType === 'phoneScreenshots',
  );
  if (!draft) return live.map((s) => ({ key: s.id, url: s.url }));
  return draft.items
    .map((it) => it.kind === 'live'
      ? { key: it.id, url: live.find((s) => s.id === it.id)?.url ?? '' }
      : { key: it.key, url: it.url ?? '' })
    .filter((x) => x.url);
}
